module.exports = __webpack_public_path__ + "img/复制.4dffe37e.svg";